import React from "react";
import { Typography } from "@material-ui/core";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import createStyles from "@material-ui/core/styles/createStyles";
import withStyles from "@material-ui/core/styles/withStyles";
import { Breadcrumb, BreadcrumbLink } from "../navigation/Breadcrumb";

const styles = (theme: Theme) =>
  createStyles({
    breadcrumb: {
      marginTop: theme.spacing(1)
    },
    pageTitle: {
      color: theme.palette.primary.dark,
      marginTop: `${theme.spacing(4)}px !important` // Prevents MUI overwriting this when a modal is active
    },
    root: {
      marginBottom: theme.spacing(4)
    }
  });

type Props = {
  breadcrumbLinks?: BreadcrumbLink[];
  classes: any;
  label: string;
};

const PageHeader = ({ breadcrumbLinks, classes, label }: Props) => (
  <div className={classes.root}>
    <Typography className={classes.pageTitle} component="h1" variant="h4">
      {label}
    </Typography>
    {breadcrumbLinks && (
      <Breadcrumb className={classes.breadcrumb} links={breadcrumbLinks} />
    )}
  </div>
);

const styled = withStyles(styles)(PageHeader);
export { styled as PageHeader };
